import type { FC } from 'react';
import Modal from '@/components/Modal';
import { ExternalLinkIcon } from '@/components/icons/ExternalLinkIcon';
import { useTranslation } from 'react-i18next';

type FullscreenLockedModalProps = {
    isOpen: boolean;
    onClose: () => void;
    onGoPlans: () => void;
};

/**
 * フルスクリーン機能がロックされていることを案内するモーダル
 */
export const FullscreenLockedModal: FC<FullscreenLockedModalProps> = ({
    isOpen,
    onClose,
    onGoPlans,
}) => {
    const { t } = useTranslation('common');

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            contentClassName="w-full max-w-md p-6"
            hideCloseButton
        >
            <div className="space-y-4">
                <h3 className="text-lg font-semibold text-center">
                    {t('actions.fullscreenEnter')}
                </h3>
                <p className="text-sm text-gray-700 whitespace-pre-line">
                    {t('actions.fullscreenLockedModalMessageLine1')}
                    {'\n'}
                    {t('actions.fullscreenLockedModalMessageLine2')}
                </p>
                <div className="flex justify-center mt-4">
                    <button
                        type="button"
                        className="px-6 py-2 rounded-md bg-kotomilThemaColor text-black hover:bg-kotomilThemaColor/90 text-sm inline-flex items-center gap-2"
                        onClick={() => {
                            onClose();
                            onGoPlans();
                        }}
                    >
                        <span>{t('actions.fullscreenLockedModalCta')}</span>
                        <ExternalLinkIcon className="h-5 w-5" />
                    </button>
                </div>
            </div>
        </Modal>
    );
};
